import React, { type ReactNode } from 'react';
import Sidebar from './Sidebar';
import Header from '../shared/Header';

interface DashboardLayoutProps {
  children: React.ReactNode;
  onSearchChange?: (query: string) => void;
  searchQuery?: string;
  onAddBookmark?: () => void;
  onFilterChange?: (filter: string) => void;
  onCategorySelect?: (category: string) => void;
  /** Highlight selected category in sidebar (combined with folder / time filters) */
  activeCategoryId?: string | null;
  /** Renders below quick filters (e.g. advanced folder / category / time filters) */
  sidebarAdvancedFilters?: ReactNode;
  /** Bookmark list layout: single column vs grid (rendered in sidebar) */
  sidebarLayoutToggle?: ReactNode;
}

export default function DashboardLayout({
  children,
  onSearchChange,
  searchQuery,
  onAddBookmark,
  onCategorySelect,
  activeCategoryId,
  sidebarAdvancedFilters,
  sidebarLayoutToggle,
}: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-[var(--sfl-bg)]">
      <Sidebar
        onCategorySelect={onCategorySelect}
        activeCategoryId={activeCategoryId}
        advancedFilters={sidebarAdvancedFilters}
        layoutToggle={sidebarLayoutToggle}
      />
              <Header onSearchChange={onSearchChange} searchQuery={searchQuery} onAddBookmark={onAddBookmark} />
      <main className="pl-64 pt-16">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6">
          {children}
        </div>
      </main>
    </div>
  );
}
